import { Container, Row, Col, Button } from "reactstrap";
import img from "../../assets/images/img.png";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";

import { FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  const circleButtonStyle = {
    borderRadius: "50%",
    width: "50px", // Adjust the width and height as needed
    height: "50px",
  };

  return (
    <div
      className="mt-5"
      style={{
        position: "relative",
        bottom: "0",
        width: "100%",
        backgroundColor: "#59b907",
        color: "white",
      }}
    >
      <footer
        className="footer p-3 p-md-5 mt-5"
        style={{ backgroundColor: "#59b907" }}
      >
        <Container className="">
          <Row className="mb-4">
            <Col md={6} lg={4}>
              <div className="d-flex g-2" style={{ flexWrap: "wrap" }}>
                <div>
                  <img
                    src={img}
                    className="img-fluid"
                    width="100"
                    alt="Logo"
                    style={{ borderRadius: "20px" }}
                  ></img>
                </div>
              </div>
            </Col>
            <Col md={3} lg={3}>
              <h5 className="fw-bolder hero-text fw-bolder">Quick Links</h5>
              <p
                className="hero-text"
                style={{ fontWeight: "300", color: "white" }}
              >
                <a
                  href="/"
                  className="text-hero"
                  style={{
                    textDecoration: "none",
                    fontWeight: "300",
                    color: "white",
                  }}
                >
                  Home
                </a>
              </p>
              <p
                className="hero-text"
                style={{ fontWeight: "300", color: "white" }}
              >
                <a
                  href="/about-us"
                  className="text-hero"
                  style={{
                    textDecoration: "none",
                    fontWeight: "300",
                    color: "white",
                  }}
                >
                  About Us
                </a>
              </p>
              <p
                className="hero-text"
                style={{ fontWeight: "300", color: "white" }}
              >
                <a
                  href="/our-team"
                  className="text-hero"
                  style={{
                    textDecoration: "none",
                    fontWeight: "300",
                    color: "white",
                  }}
                >
                  Our Team
                </a>
              </p>
              <p
                className="hero-text"
                style={{ fontWeight: "300", color: "white" }}
              >
                <a
                  href="/services"
                  className="text-hero"
                  style={{
                    textDecoration: "none",
                    fontWeight: "300",
                    color: "white",
                  }}
                >
                  Services
                </a>
              </p>
              <p
                className="hero-text"
                style={{ fontWeight: "300", color: "white" }}
              >
                <a
                  href="/contact-us"
                  className="text-hero"
                  style={{
                    textDecoration: "none",
                    fontWeight: "300",
                    color: "white",
                  }}
                >
                  Contact
                </a>
              </p>
            </Col>
            <Col md={3} lg={3}>
              <h5 className="fw-bolder hero-text fw-bolder">Let's Connect!</h5>
              <p
                className="hero-text"
                style={{
                  textDecoration: "none",
                  fontWeight: "300",
                  color: "black",
                  fontSize: '0.8rem'
                }}
              >
                Connect with entrepreneurs, build your network, make great
                business.
              </p>

              <div>
                <div className="d-flex " style={{ columnGap: "15px" }}>
                  <div
                    style={{
                      width: "34px",
                      height: "34px",
                      backgroundColor: "#59b907",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                    className="p-1 d-flex justify-content-center align-items-center"
                  >
                    <FaTwitter
                      className="text-light "
                      style={{ fontSize: "15px" }}
                    />
                  </div>
                  <div
                    style={{
                      width: "34px",
                      height: "34px",
                      backgroundColor: "#59b907",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                    className="p-1 d-flex justify-content-center align-items-center"
                  >
                    <FaLinkedinIn
                      className="text-light"
                      style={{ fontSize: "15px" }}
                    />
                  </div>
                  <div
                    style={{
                      width: "34px",
                      height: "34px",
                      backgroundColor: "#59b907",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                    className="p-1 d-flex justify-content-center align-items-center"
                  >
                    <FaInstagram
                      className="text-light"
                      style={{ fontSize: "15px" }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <hr className="mt-4 mb-3" />

          <Row>
            <Col md={6} className="text-center">
              <p  className="hero-text"
                style={{
                  textDecoration: "none",
                  fontWeight: "300",
                  color: "white",
                  fontSize: '0.8rem'
                }}>
                © {new Date().getFullYear()} Desiderata Informations Systems LTD. All
                rights reserved.
              </p>
            </Col>
            <Col md={6} className="text-center">
              <p  className="hero-text"
                style={{
                  textDecoration: "none",
                  fontWeight: "300",
                  color: "white",
                  fontSize: '0.8rem'
                }}>
              Powered by Desiderata
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
